import config from '../config.json'
const hostname = window.location.hostname

export const validateStatus = (state) => {
  const status = [200, 201, 202, 203, 204, 204]
  if (status && status.indexOf(state) > -1) {
    return true
  }
  return false
}
export const validateArray = (list) => {
  return list && Array.isArray(list) && list.length > 0
}

export const validateUrlToOpen = (url, institutionParam) => {
  if (url && typeof url === "string" && url?.startsWith("/")) {
    if (hostname === config.hostname) {
      if (institutionParam?.find((i) => i.code === "mediaRequest")?.value) {
        return (
          institutionParam?.find((i) => i.code === "mediaRequest")?.value + url
        );
      }
      return url;
    } else {
      if (institutionParam?.find((i) => i.code === "mediaRequest2")?.value) {
        return (
          institutionParam?.find((i) => i.code === "mediaRequest2")?.value + url
        );
      }
      return url;
    }
  }

  return url;
};

export const readerActionValidator = (fieldUrl, procedureId) => {
  if (fieldUrl != null && fieldUrl !== "") {
    return fieldUrl.replace('{procedureId}', procedureId)
  }
  return fieldUrl;
}

export const roundToNearest = (value, multiple = 1) => {
  return Math.round(value / multiple) * multiple;
};

export function parseJsonSafe(jsonString) {
  if (!jsonString || typeof jsonString !== 'string') return null;

  try {
    const parsed = JSON.parse(jsonString);
    return parsed;
  } catch (error) {
    return null;
  }
}

export function handleToJson(list) {
  if (validateArray(list)) {
    let auxJson = {};
    list.forEach((element) => {
      auxJson = { ...auxJson, [element.code]: element.value };
    });
    return auxJson;
  }
  return {};
}

export const formatDatePerType = (date, format) => {
  console.log(format);
  if (format === "input") {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
  } else if (format === "localtime") {
    return date.toLocaleTimeString("es-BO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } else if (format === "datetimeString") {
    const newDate = new Date(date);

    const daysOfWeek = [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ];
    const months = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];

    const dayOfWeek = daysOfWeek[newDate.getDay()];
    const day = newDate.getDate();
    const month = months[newDate.getMonth()];
    const year = newDate.getFullYear();
    const hour = newDate.getHours();
    const minute = newDate.getMinutes();

    return `${dayOfWeek}, ${day} de ${month} de ${year} a las ${hour
      .toLocaleString()
      .padStart(2, "0")}:${minute.toLocaleString().padStart(2, "0")}`;
  } else {
    return date.toLocaleDateString("es-BO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }
};